import React, { useState, useEffect, useContext } from "react";
import MUIDataTable from "mui-datatables";
import ijws from "../../../services/ijws";
import peij from "../../../services/peij";
import {
  formatDateTime,
  isoToSqlDate,
  mergeParams,
} from "../../../helpers/helpers";
import { CircularProgress } from "@mui/material";
import Form from "../../../components/form";
import AppContext from "../../../container/context";

const AssinaturasAVencer = ({ history, match, location }) => {
  const { notification } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [registros, setRegistros] = useState([]);
  const [linkTxt, setLinkTxt] = useState("");
  const [registroSelecionado, setRegistroSelecionado] = useState({});
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        dataInicio: `${new Date().getFullYear()}-${(new Date().getMonth() - 1)
          .toString()
          .padStart(2, "0")}-01`,
        dataFim: isoToSqlDate(new Date().toISOString()),
      },
      location
    )
  );
  const [totais, setTotais] = useState({
    preCadastros: 0,
    cadastros: 0,
    assinaturas: 0,
    percCadastros: 0,
    percAssinaturas: 0,
  });

  useEffect(() => {
    carregarRelatorio();
  }, []);

  const carregarRelatorio = (filtrosAtualizados = filtros) => {
    setCarregando(true);
    setRegistroSelecionado({});
    setFiltros(filtrosAtualizados);

    ijws
      .get("admin/relatorios/assinaturasAVencer", filtrosAtualizados)
      .then((res) => {
        res.forEach((r) => {
          r.dataAssinatura = r.dataAssinatura
            ? formatDateTime(r.dataAssinatura, "D/M/Y")
            : "-";
          r.ultimoAcesso = r.ultimoAcesso
            ? formatDateTime(r.ultimoAcesso, "D/M/Y")
            : "-";
          r.assinaturaVencimento = r.assinaturaVencimento
            ? formatDateTime(r.assinaturaVencimento, "D/M/Y")
            : "-";
        });

        setRegistros(res);
        setCarregando(false);
      });
  };

  const salvarContato = (formulario) => {
    const registroSalvar = {
      ...formulario,
      preCadastroId: registroSelecionado.preCadastroId,
    };

    peij
      .post("pre-cadastros/inserirContato", registroSalvar)
      .then((res) => {
        if (res.includes(200)) {
          notification("success", "Dados salvos!");
          carregarRelatorio();
        } else {
          notification(
            "error",
            "Não foi possível salvar os dados. Verifique as informações e tente novamente."
          );
        }
      })
      .catch((err) => {
        console.log(err);
        notification(
          "error",
          "Não foi possível salvar os dados. Verifique as informações e tente novamente."
        );
      });
  };

  const definirSituacaoRegistro = (registro, dataAtual) => {
    if (!registro.inicio) {
      if (new Date(registro.previsaoInicio) < dataAtual) return "Atrasado";
      return "Não iniciado";
    }
    if (!registro.termino) return "Em andamento";
    return "Finalizado";
  };

  const getFiltros = (filtros) => ({
    dataInicio: {
      label: "Vence a partir de",
      type: "date",
      value: filtros.dataInicio,
      space: 6,
    },
    dataFim: {
      label: "Vence até",
      type: "date",
      value: filtros.dataFim,
      space: 6,
    },
  });

  const formRegistroSelecionado = (registroSelecionado) => ({
    usuarioNome: {
      label: "Usuário",
      type: "text",
      value: registroSelecionado.usuarioNome,
      readOnly: true,
      space: 4,
    },
    usuarioEmail: {
      label: "Email",
      type: "text",
      value: registroSelecionado.usuarioEmail,
      readOnly: true,
      space: 4,
    },
    usuarioTelefone: {
      label: "Telefone",
      type: "text",
      value: registroSelecionado.usuarioTelefone,
      readOnly: true,
      space: 4,
    },
    dataAssinatura: {
      label: "Início da assinatura",
      type: "text",
      value: registroSelecionado.dataAssinatura,
      readOnly: true,
      space: 4,
    },
    assinaturaVencimento: {
      label: "Fim da assinatura",
      type: "text",
      value: registroSelecionado.assinaturaVencimento,
      readOnly: true,
      space: 4,
    },
    ultimoAcesso: {
      label: "Último acesso à plataforma",
      type: "text",
      value: registroSelecionado.ultimoAcesso,
      readOnly: true,
      space: 4,
    },
    tipoCompra: {
      label: "Tipo de compra",
      type: "textarea",
      readOnly: true,
      value:
        registroSelecionado.idFaturaIugu === "DIRETA"
          ? "Compra direta (pix, transferência ou boleto)"
          : `Via plataforma (Id da fatura IUGU: ${registroSelecionado.idFaturaIugu})`,
    },
  });

  const camposToken = (registroSelecionado) => ({
    valor: {
      label: "Valor R$",
      type: "number",
      value: registroSelecionado.tokenPagamentoValor,
      space: 3,
      readOnly: true,
    },
    maxParcelas: {
      label: "Máximo de parcelas",
      type: "number",
      value: registroSelecionado.tokenPagamentoMaxParcelas,
      space: 3,
      readOnly: true,
    },
    duracaoAssinatura: {
      label: "Duração da assinatura (meses)",
      type: "number",
      value: registroSelecionado.tokenPagamentoDuracaoAssinatura,
      space: 3,
      readOnly: true,
    },
    validade: {
      label: "Validade do link de pagamento",
      type: "date",
      value: registroSelecionado.tokenPagamentoValidade
        ? formatDateTime(registroSelecionado.tokenPagamentoValidade, "D/M/Y")
        : null,
      space: 3,
      required: true,
      readOnly: true,
    },
    labelLink: {
      label: "Link para pagamento",
      type: "component",
      value: <h4>Link para pagamento</h4>,
    },
    link: {
      label: "Link para pagamento",
      type: "component",
      value: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={registroSelecionado.tokenPagamentoLink}
          style={{ marginBottom: 30 }}
        >
          {registroSelecionado.tokenPagamentoLink}
        </a>
      ),
    },
  });

  const columns = [
    {
      name: "usuarioNome",
      label: "Nome",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "usuarioEmail",
      label: "Email",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "usuarioTelefone",
      label: "Telefone",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "dataAssinatura",
      label: "Início da assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "assinaturaVencimento",
      label: "Vencimento da assinatura",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "ultimoAcesso",
      label: "Último acesso à plataforma",
      options: {
        filter: false,
        sort: false,
      },
    },
    // {
    //   name: "detalhes",
    //   label: "Detalhes da assinatura",
    //   options: {
    //     filter: false,
    //     sort: false,
    //   },
    // },
    // {
    //   name: "tokenPagamento",
    //   label: "Token de pagamento",
    //   options: {
    //     filter: false,
    //     sort: false,
    //   },
    // },
  ];

  const options = {
    filterType: "checkbox",
    selectableRows: "none",
    rowsPerPage: 50,
    downloadOptions: {
      filename: "pre-cadastros.csv",
      separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  const fFiltros = {
    title: "Filtros",
    form: getFiltros(filtros),
    submit: {
      label: "Carregar",
      action: carregarRelatorio,
    },
  };

  const fRegistroSelecionado = {
    title: "Registro selecionado",
    form: formRegistroSelecionado(registroSelecionado),
    submit: {
      label: "Salvar",
      action: salvarContato,
    },
    close: { action: () => setRegistroSelecionado({}) },
  };

  const fToken = {
    title: "Token de pagamento para renovação",
    form: registroSelecionado.tokenPagamentoCodigo
      ? camposToken(registroSelecionado)
      : {
          label: {
            name: "Link para pagamento",
            type: "component",
            value: <p>O usuário não possui token de pagamento ativo.</p>,
          },
        },
    submit: registroSelecionado.tokenPagamentoCodigo
      ? {
          label: "Editar token",
          action: () =>
            history.push(
              `/app/token-pagamento-ij/${registroSelecionado.tokenPagamentoCodigo}`
            ),
        }
      : {
          label: "Gerar token",
          action: () =>
            history.push(
              `/app/token-pagamento-ij/geracao/${registroSelecionado.usuarioId}`
            ),
        },
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? (
        <CircularProgress />
      ) : registroSelecionado.usuarioId ? (
        <div>
          <Form formData={fRegistroSelecionado} />
          <Form formData={fToken} />
        </div>
      ) : (
        <MUIDataTable
          title="Inglês Juntos - Assinaturas a vencer"
          data={registros}
          columns={columns}
          options={options}
        />
      )}
    </div>
  );
};

export default AssinaturasAVencer;
